import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MpWelcomeComponent } from './mp-welcome/mp-welcome.component';
import { MpTotalProjectsComponent } from './mp-total-projects/mp-total-projects.component';
import { MpTotalOrdersComponent } from './mp-total-orders/mp-total-orders.component';
import { MpTotalRevenueComponent } from './mp-total-revenue/mp-total-revenue.component';
import { MpProfileIntroComponent } from './mp-profile-intro/mp-profile-intro.component';
import { MpProfileInformationComponent } from './mp-profile-information/mp-profile-information.component';
import { MpAdditionalInformationComponent } from './mp-additional-information/mp-additional-information.component';
import { MpRecentActivityComponent } from './mp-recent-activity/mp-recent-activity.component';
import { MpToDoListComponent } from './mp-to-do-list/mp-to-do-list.component';
import { MpOverviewComponent } from './mp-overview/mp-overview.component';
import { FormGroup, FormControl } from '@angular/forms';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { ConfigDataService } from '../../../data-services/config-data.service';
import { ItemSelectionChanged } from '../../../ui-framework/core-controls/selection-list-base/selection-list.component';
import { AppEnvironmentService } from '../../../ui-framework/global-services/app-environment.service';
import { ServiceContainerService } from '../../../ui-framework/global-services/service-container.service';
import { MasterListItem, UserDetails } from '../../../data-services/api-models/config-service-models';
import { Functionality } from '../../../data-services/api-models/shared-models';

@Component({
    selector: 'app-my-profile',
    imports: [RouterLink, MpWelcomeComponent, MpTotalProjectsComponent, MpTotalOrdersComponent, MpTotalRevenueComponent, MpProfileIntroComponent, MpProfileInformationComponent, MpAdditionalInformationComponent, MpRecentActivityComponent, MpToDoListComponent, MpOverviewComponent],
    templateUrl: './my-profile.component.html',
    styleUrl: './my-profile.component.scss'
})
export class MyProfileComponent {
    canSetModuleAdmin: boolean = false;
    currentUserId: string = '';
    _selectedUserRoleId: string = '';
    selectedRole!: MasterListItem;
    reactiveForm: FormGroup<MyProfileForm>;
    id: string | undefined;
    constructor(
        private configService: ConfigDataService,
        private appEnv: ServiceContainerService,
        route: ActivatedRoute,
        private router: Router
    ) {
        this.reactiveForm = new FormGroup(new MyProfileForm())
        this.id = route.snapshot.paramMap.get('id') ?? undefined;
    }


    showPasswordField: boolean = true;
    showControl: boolean = true;
    ngOnInit(): void {
        this.configService.getUserMaster(this.id!)
            .subscribe((userItem: any) => {
                this.reactiveForm?.setValue({
                    userId: userItem.userId ?? userItem.code ?? '',
                    firstName: userItem.firstName ?? '',
                    lastName: userItem.lastName ?? '',
                    mobile: userItem.mobilePhoneNumber ?? "",
                    email: userItem.emailId ?? "",
                }
                );
                this.reactiveForm?.controls['userId'].disable();
            });
    }

    setModelData(): UserDetails {
        const form = this.reactiveForm;
        let model: UserDetails = {
            id: '', code: '', isActive: true, functionalityId: Functionality.UserMaster,
            userId: undefined,
            firstName: undefined,
            lastName: undefined,
            mobilePhoneNumber: undefined,
            emailId: undefined,
            password: '',
            passwordHint: undefined,
            isLocked: false,
            isBlocked: false,
            isExternal: false,
            isImported: false,

        } // id is ignored by remote service
        if (form) {
            const formValues = form.getRawValue();
            model.userId = formValues.userId ?? '';
            model.firstName = formValues?.firstName ?? '';
            model.lastName = formValues?.lastName ?? '';
            model.mobilePhoneNumber = formValues?.mobile ?? '';
            model.emailId = formValues?.email ?? '';
            model.code = formValues?.userId ?? '';
        }

        return model;
    }

    setFormData(model: UserDetails | undefined) {
        if (model) {
            this.reactiveForm?.setValue({
                userId: model.userId ?? model.code ?? '',
                firstName: model.firstName!,
                lastName: model.lastName!,
                mobile: model.mobilePhoneNumber ?? "",
                email: model.emailId ?? ""
            }
            );
        }
        else {
            this.reactiveForm?.setValue({
                // code: '',
                firstName: '',
                lastName: '',
                mobile: '',
                email: '',

                // name: '',
                userId: '',

            });
        }
    }

    sendUpdateModelRequest() {
        let model = this.setModelData();
        this.appEnv.spinnerService
            .runObservableOperation(() => this.configService.updateUserMaster(this.id!, model, true))
            .subscribe((data) => {
                console.log(data)
                this.appEnv.alertsService.showSuccessAlert('User Updated').subscribe();
            })
            ;
    }

    clearFormData(): void {

    }

    roleSelectionChanged(eventParam: ItemSelectionChanged<MasterListItem>) {
        let currentRow: MasterListItem;
        var newValue = null;
        if (eventParam && eventParam.selection && eventParam.selection.length === 1) {
            newValue = eventParam.selection[0].id;
            currentRow = eventParam.selection[0];
        }

        if (this._selectedUserRoleId != newValue) {
            this._selectedUserRoleId = newValue!.toString();
            this.selectedRole = currentRow!;
        }
    }
}

export class MyProfileForm {
    public userId = new FormControl<string | null | undefined>('', { validators: [RxwebValidators.required({ message: "User Id is required" })] });
    public firstName = new FormControl<string>('', { validators: [RxwebValidators.maxLength({ value: 50 })] });
    public lastName = new FormControl<string>('', { validators: [RxwebValidators.maxLength({ value: 50 })] });
    public mobile = new FormControl<string>('', { validators: [RxwebValidators.maxLength({ value: 50 })] });
    public email = new FormControl<string>('', { validators: [RxwebValidators.maxLength({ value: 50 })] });
}